const actionNames = {
  SHOW_INTERNAL_VIEW: 'SHOW_INTERNAL_VIEW',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',

  GET_INTERNAL_REQUESTED: 'GET_INTERNAL_REQUESTED',
  GET_INTERNAL_SUCCEEDED: 'GET_INTERNAL_SUCCEEDED',
  GET_INTERNAL_FAILED: 'GET_INTERNAL_FAILED',

  ADD_INTERNAL_REQUESTED: 'ADD_INTERNAL_REQUESTED',
  ADD_INTERNAL_SUCCEEDED: 'ADD_INTERNAL_SUCCEEDED',
  ADD_INTERNAL_FAILED: 'ADD_INTERNAL_FAILED',

  EDIT_INTERNAL_REQUESTED: 'EDIT_INTERNAL_REQUESTED',
  EDIT_INTERNAL_SUCCEEDED: 'EDIT_INTERNAL_SUCCEEDED',
  EDIT_INTERNAL_FAILED: 'EDIT_INTERNAL_FAILED',

  DELETE_INTERNAL_REQUESTED: 'DELETE_INTERNAL_REQUESTED',
  DELETE_INTERNAL_SUCCEEDED: 'DELETE_INTERNAL_SUCCEEDED',
  DELETE_INTERNAL_FAILED: 'DELETE_INTERNAL_FAILED',

  GET_MANAGER_REQUESTED: 'GET_MANAGER_REQUESTED',
  GET_MANAGER_SUCCEEDED: 'GET_MANAGER_SUCCEEDED',
  GET_MANAGER_FAILED: 'GET_MANAGER_FAILED',

  GET_CLIENTS_REQUESTED: 'GET_CLIENTS_REQUESTED',
  GET_CLIENTS_SUCCEEDED: 'GET_CLIENTS_SUCCEEDED',
  GET_CLIENTS_FAILED: 'GET_CLIENTS_FAILED',

  GET_ORGANIZATION_REQUESTED: 'GET_ORGANIZATION_REQUESTED',
  GET_ORGANIZATION_SUCCEEDED: 'GET_ORGANIZATION_SUCCEEDED',
  GET_ORGANIZATION_FAILED: 'GET_ORGANIZATION_FAILED',

  GET_ORGANIZATIONS_REQUESTED: 'GET_ORGANIZATIONS_REQUESTED',
  GET_ORGANIZATIONS_SUCCEEDED: 'GET_ORGANIZATIONS_SUCCEEDED',
  GET_ORGANIZATIONS_FAILED: 'GET_ORGANIZATIONS_FAILED',

  ADD_ORGANIZATION_REQUESTED: 'ADD_ORGANIZATION_REQUESTED',
  ADD_ORGANIZATION_SUCCEEDED: 'ADD_ORGANIZATION_SUCCEEDED',
  ADD_ORGANIZATION_FAILED: 'ADD_ORGANIZATION_FAILED',

  EDIT_ORGANIZATION_REQUESTED: 'EDIT_ORGANIZATION_REQUESTED',
  EDIT_ORGANIZATION_SUCCEEDED: 'EDIT_ORGANIZATION_SUCCEEDED',
  EDIT_ORGANIZATION_FAILED: 'EDIT_ORGANIZATION_FAILED',

  DELETE_ORGANIZATION_REQUESTED: 'DELETE_ORGANIZATION_REQUESTED',
  DELETE_ORGANIZATION_SUCCEEDED: 'DELETE_ORGANIZATION_SUCCEEDED',
  DELETE_ORGANIZATION_FAILED: 'DELETE_ORGANIZATION_FAILED',

  GET_TIME_ROLLUP_REQUESTED: 'GET_TIME_ROLLUP_REQUESTED',
  GET_TIME_ROLLUP_SUCCEEDED: 'GET_TIME_ROLLUP_SUCCEEDED',
  GET_TIME_ROLLUP_FAILED: 'GET_TIME_ROLLUP_FAILED',

  GET_PERSON_REQUESTED: 'GET_PERSON_REQUESTED',
  GET_PERSON_SUCCEEDED: 'GET_PERSON_SUCCEEDED',
  GET_PERSON_FAILED: 'GET_PERSON_FAILED',

  ADD_PERSON_REQUESTED: 'ADD_PERSON_REQUESTED',
  ADD_PERSON_SUCCEEDED: 'ADD_PERSON_SUCCEEDED',
  ADD_PERSON_FAILED: 'ADD_PERSON_FAILED',

  EDIT_PERSON_REQUESTED: 'EDIT_PERSON_REQUESTED',
  EDIT_PERSON_SUCCEEDED: 'EDIT_PERSON_SUCCEEDED',
  EDIT_PERSON_FAILED: 'EDIT_PERSON_FAILED',

  DELETE_PERSON_REQUESTED: 'DELETE_PERSON_REQUESTED',
  DELETE_PERSON_SUCCEEDED: 'DELETE_PERSON_SUCCEEDED',
  DELETE_PERSON_FAILED: 'DELETE_PERSON_FAILED',

  GET_PROJECTS_REQUESTED: 'GET_PROJECTS_REQUESTED',
  GET_PROJECTS_SUCCEEDED: 'GET_PROJECTS_SUCCEEDED',
  GET_PROJECTS_FAILED: 'GET_PROJECTS_FAILED',

  GET_PROJECT_REQUESTED: 'GET_PROJECT_REQUESTED',
  GET_PROJECT_SUCCEEDED: 'GET_PROJECT_SUCCEEDED',
  GET_PROJECT_FAILED: 'GET_PROJECT_FAILED',

  ADD_PROJECT_REQUESTED: 'ADD_PROJECT_REQUESTED',
  ADD_PROJECT_SUCCEEDED: 'ADD_PROJECT_SUCCEEDED',
  ADD_PROJECT_FAILED: 'ADD_PROJECT_FAILED',

  EDIT_PROJECT_REQUESTED: 'EDIT_PROJECT_REQUESTED',
  EDIT_PROJECT_SUCCEEDED: 'EDIT_PROJECT_SUCCEEDED',
  EDIT_PROJECT_FAILED: 'EDIT_PROJECT_FAILED',

  DELETE_PROJECT_REQUESTED: 'DELETE_PROJECT_REQUESTED',
  DELETE_PROJECT_SUCCEEDED: 'DELETE_PROJECT_SUCCEEDED',
  DELETE_PROJECT_FAILED: 'DELETE_PROJECT_FAILED',

  GET_PUBLISHER_REQUESTED: 'GET_PUBLISHER_REQUESTED',
  GET_PUBLISHER_SUCCEEDED: 'GET_PUBLISHER_SUCCEEDED',
  GET_PUBLISHER_FAILED: 'GET_PUBLISHER_FAILED',

  GET_PUBLISHERS_REQUESTED: 'GET_PUBLISHERS_REQUESTED',
  GET_PUBLISHERS_SUCCEEDED: 'GET_PUBLISHERS_SUCCEEDED',
  GET_PUBLISHERS_FAILED: 'GET_PUBLISHERS_FAILED',

  GET_SERVICE_REQUESTED: 'GET_SERVICE_REQUESTED',
  GET_SERVICE_SUCCEEDED: 'GET_SERVICE_SUCCEEDED',
  GET_SERVICE_FAILED: 'GET_SERVICE_FAILED',

  GET_TIMETYPE_REQUESTED: 'GET_TIMETYPE_REQUESTED',
  GET_TIMETYPE_FAILED: 'GET_TIMETYPE_FAILED',
  GET_TIMETYPE_SUCCEEDED: 'GET_TIMETYPE_SUCCEEDED',

  GET_TIME_REQUESTED: 'GET_TIME_REQUESTED',
  GET_TIME_SUCCEEDED: 'GET_TIME_SUCCEEDED',
  GET_TIME_FAILED: 'GET_TIME_FAILED',

  ADD_TIME_REQUESTED: 'ADD_TIME_REQUESTED',
  ADD_TIME_SUCCEEDED: 'ADD_TIME_SUCCEEDED',
  ADD_TIME_FAILED: 'ADD_TIME_FAILED',

  EDIT_TIME_REQUESTED: 'EDIT_TIME_REQUESTED',
  EDIT_TIME_SUCCEEDED: 'EDIT_TIME_SUCCEEDED',
  EDIT_TIME_FAILED: 'EDIT_TIME_FAILED',

  DELETE_TIME_REQUESTED: 'DELETE_TIME_REQUESTED',
  DELETE_TIME_SUCCEEDED: 'DELETE_TIME_SUCCEEDED',
  DELETE_TIME_FAILED: 'DELETE_TIME_FAILED',

  GET_WEEK_REQUESTED: 'GET_WEEK_REQUESTED',
  GET_WEEK_SUCCEEDED: 'GET_WEEK_SUCCEEDED',
  GET_WEEK_FAILED: 'GET_WEEK_FAILED',
}

export default actionNames
